$(document).ready(function(){

	// assign the current url to a var
	var nextPage = $(".load-more").data('url');

	$("body").on("click", ".load-more", function(){

		// disable the button on load
		$(".load-more").attr("disabled", true);
		$(".load-more span").text("Loading...");

		if (nextPage != "" ){
			$.get(nextPage).done(function(data){
				appendArticle(data);
			});

			function appendArticle(param){
				$(".articles").append($(param).find(".article").addClass("new"));

				// $('.article.new').each(function(i){
				// 	$('.article.new').imagesLoaded( function() {
				// 		setTimeout(function(){
				// 			$('.article.new').addClass("showUp");
				// 			console.log("wesd");
				// 		}, i*100);
				// 	});
				// });
				
				nextPage = $(param).find(".load-more").data('url');

				if (nextPage == ""){
					$(".load-more").text("No more posts");
				} else {
					$(".load-more").attr("disabled", false);
					$(".load-more span").text("Load More");
				}
			}
		}
		

	});

});